"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OntologyConfig = void 0;
const Tokens_1 = require("./Tokens");
const Types_1 = require("../../Types");
const MetamaskConnector_1 = require("../../Connectors/Wallets/MetamaskConnector");
const Utils_1 = require("../Utils");
const MetamaskCompatibleConnector_1 = require("../../Connectors/Wallets/MetamaskCompatibleConnector");
const Factory_1 = require("../../Connectors/Factory");
const Utils_2 = require("../../Connectors/Utils");
const OntoWallet_1 = require("../../Connectors/Wallets/OntoWallet");
const WalletConnectConnector_1 = require("../../Connectors/Wallets/WalletConnectConnector");
const CoinbaseConnector_1 = require("../../Connectors/Wallets/CoinbaseConnector");
const TokenPocketConnector_1 = require("../../Connectors/Wallets/TokenPocketConnector");
exports.OntologyConfig = Utils_1.blockchainConfigFactory({
    blockchain: Types_1.Blockchains.Ontology,
    chainId: Types_1.EthChainIds.Ontology,
    publicRpc: Utils_2.unifiBlockchainProxyUrl(Types_1.Blockchains.Ontology),
    nativeToken: Tokens_1.ONGNativeToken,
    wrappedToken: Tokens_1.ONGWrappedToken,
    upToken: Tokens_1.ONGUpToken,
    unfiToken: Tokens_1.ONGUnfiToken,
    logoURI: "https://proxy.unifiprotocol.com/ipfs/QmabRMMq64jyBxhRkALfDM7ucJZc83xNZf8XVVr2S4GETq",
    multicall: {
        supported: true,
        address: "0xF0FccF333d45B383A9086739Ab8176BeDDd5a519",
        tryAggregate: false,
    },
    connectorFactory: Factory_1.web3ConnectorFactory,
    explorer: {
        baseUrl: `https://explorer.ont.io`,
        address: function (address) {
            return `${this.baseUrl}/address/${address}`;
        },
        token: function (address) {
            return `${this.baseUrl}/token/${address}`;
        },
        tx: function (address) {
            return `${this.baseUrl}/tx/${address}`;
        },
    },
}, [
    MetamaskConnector_1.MetamaskConnector,
    TokenPocketConnector_1.TokenPocketConnector,
    MetamaskCompatibleConnector_1.MetamaskCompatibleConnector,
    OntoWallet_1.OntoWalletConnector,
    CoinbaseConnector_1.CoinbaseWalletConnector,
    WalletConnectConnector_1.WalletConnectConnector,
], [
    Factory_1.createWeb3OfflineConnectorHelper(Types_1.OfflineConnectors.UnifiProxy, Utils_2.unifiBlockchainProxyUrl(Types_1.Blockchains.Ontology)),
]);
